"use client";

import Link from "next/link";
import LABELS from "@/components/global-constant/src/general";
import { useGeneralSettings } from "@/packages/context/GeneralSettingContext";
import NextImage from "./NextImage";

export default function Logo() {
  const siteSettings = useGeneralSettings();
  return (
    <Link href="/" className="shrink-0 block">
      {/* Desktop Logo */}
      <NextImage
        src={
          siteSettings.settings?.logo.image.trim() ||
          "/assets/site/images/logo.png"
        }
        alt="logo"
        width={90}
        height={28}
        className="hidden sm:block  object-contain"
      />

      {/* Mobile Logo */}
      <NextImage
        src={LABELS.LOGO.mobileImageUrl || "/assets/site/images/logo.png"}
        alt="logo"
        width={40}
        height={150}
        className="block sm:hidden w-auto h-13 "
      />
    </Link>
  );
}
